

































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import TicketList from '@/components/Admin/Lists/TicketList.vue';
import PreviewTicketInfo from '@/components/Admin/Panels/Ticket/PreviewTicketInfo.vue';

@Component({
    components: {
        TicketList,
        PreviewTicketInfo,
    },
    computed: {
        ...mapGetters({
            allTickets: 'Tickets/getAllTickets',
            ticketInfoVisible: 'Tickets/getTicketInfoVisible',
            ticketInfo: 'Tickets/getTicketInfo',
        }),
    },
})
export default class Tickets extends Vue {
    public tabs: any[] = [
        {
            title: 'All Tickets',
            translations_key: 'all-tickets',
            status: true,
            requestOption: 'all',
        },
        {
            title: 'Pending',
            translations_key: 'pending',
            status: false,
            requestOption: 'pending',
        },
        {
            title: 'In-progress',
            translations_key: 'in-progress',
            status: false,
            requestOption: 'in-progress',
        },
        {
            title: 'Completed',
            translations_key: 'completed',
            status: false,
            requestOption: 'completed',
        },
        {
            title: 'Cancelled',
            translations_key: 'cancelled',
            status: false,
            requestOption: 'cancelled',
        },
    ];

    constructor() {
        super();
    }

    public toggleTicketsTab(tabIndex: any) {
        if (!this.tabs[tabIndex].status) {
            this.$store.dispatch(Actions.FETCH_ALL_TICKETS, {
                vue: this,
                type: this.tabs[tabIndex].requestOption,
                column: 'id',
                dir: 'desc',
            });

            this.$store.dispatch(Actions.RESET_ACTIVE_TICKET_ROWS);
            this.tabs.forEach((tab) => tab.status = false);
            this.tabs[tabIndex].status = true;
        }
    }

    public fetchCurrentTicket(ticketId: number) {
        this.$store.dispatch(Actions.FETCH_CURRENT_TICKET, ticketId);
    }

    public setHeaderClass(state: string) {
        if (state === 'open') {
            return 'ticket-grid-item-header-active';
        } else if (state === 'new') {
            return 'ticket-grid-item-header-inactive';
        } else if (state === 'resolved') {
            return 'ticket-grid-item-header-canceled';
        } else {
            return 'ticket-grid-item-header-passive';
        }
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_TICKETS, {vue: this, type: 'all', column: 'id', dir: 'desc'});
    }
}
